/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Button,
    TextField,
} from "@mui/material";
import SwitchToggle from "../../components/SwitchToggle";
import DragHandleIcon from '@mui/icons-material/DragHandle';
import CreateNewHomeLayout from "../../Modals/createnelayout";
import EditTags from "../../Modals/edittags";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const HomeLayout = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const subscriptionData = [
        { id: "L001", label: "Trending Now", type: "Trending", typeColor: "#10b981", ctr: "6.7%", conv: "42%", tags: true },
        { id: "L002", label: "Shop by Category", type: "Category", typeColor: "#f59e0b", ctr: "6.8%", conv: "85%", tags: true },
        { id: "L003", label: "Featured Products", type: "Products", typeColor: "#f59e0b", ctr: "6.7%", conv: "35%", tags: true },
        { id: "L004", label: "Most Popular in UAE", type: "Trending", typeColor: "#10b981", ctr: "5.2%", conv: "28%", tags: true },
        { id: "L005", label: "Shop the Reel", type: "Reels", typeColor: "#6366f1", ctr: "8.9%", conv: "12%", tags: false },
        { id: "L006", label: "New Arrivals", type: "Products", typeColor: "#f59e0b", ctr: "7.1%", conv: "56%", tags: true },
        { id: "L007", label: "Best Sellers", type: "Trending", typeColor: "#10b981", ctr: "6.4%", conv: "68%", tags: true },
        { id: "L008", label: "Flash Deals", type: "Promotions", typeColor: "#ef4444", ctr: "9.5%", conv: "92%", tags: false },
    ];
    const [open, setOpen] = useState(false);
    const handleCloseModal = () => {
        setOpen(false);
    };
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    return (
        <>
            <div className="main_title">
                <h1> Home Layout</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Home Layout
                </p>
            </div>
            <div className="stats_boxes gap_m">

                {/* TOTAL STRUCTURES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            12
                            <p>Total Layouts</p>
                        </h2>
                        <figure className="blue">
                            <AccountTreeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight info">
                        <span>Configured</span>
                        <small>across platform</small>
                    </div>
                </a>

                {/* ACTIVE STRUCTURES */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            11
                            <p>Active Layouts</p>
                        </h2>
                        <figure className="sucess">
                            <CheckCircleOutlineIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>92%</span>
                        <small>activation rate</small>
                    </div>
                </a>

                {/* COMMUNITY MEMBERS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            2
                            <p>Default Layouts</p>
                        </h2>
                        <figure className="active_order">
                            <GroupsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>

                    <div className="ai_insight positive">
                        <span>▲ 22%</span>
                        <small>vs last 300 days</small>
                    </div>
                </a>



            </div>
            <div className="table_flex mt_20">
                <div className="lt">

                    <div className="cards ">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search ..."
                                    />
                                </Box>
                            </div>
                            <div className="right_s">
                                <Button className="btn btn_primary" onClick={() => setOpen(true)}>Create New</Button>
                            </div>
                        </div>
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Label</TableCell>
                                        <TableCell>Display Name</TableCell>
                                        <TableCell>Show</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Performance</TableCell>
                                        <TableCell>Tags</TableCell>
                                        <TableCell >Drag/Drop</TableCell>
                                        <TableCell align="center">Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {subscriptionData.map((item, index) => (
                                        <TableRow key={item.id} hover>
                                            {/* Sr No */}
                                            <TableCell>{index + 1}</TableCell>

                                            {/* Label */}
                                            <TableCell>
                                                <span className="label_text" style={{ fontWeight: '600' }}>{item.label}</span>
                                            </TableCell>

                                            {/* Display Name */}
                                            <TableCell className="form" style={{ minWidth: '220px' }}>
                                                <Box position="relative">
                                                    <TextField
                                                        size="small"
                                                        fullWidth
                                                        defaultValue={item.label}
                                                    />

                                                </Box>
                                            </TableCell>

                                            {/* Show Toggle */}
                                            <TableCell>
                                                <SwitchToggle checked />
                                            </TableCell>

                                            {/* Type */}
                                            <TableCell>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: item.typeColor }}></span>
                                                    <span style={{ fontSize: '13px', color: '#666' }}>{item.type}</span>
                                                </Box>
                                            </TableCell>

                                            {/* Performance */}
                                            <TableCell>
                                                <Box display="flex" alignItems="center" gap={2} style={{ fontSize: '13px', color: '#666' }}>
                                                    <Box display="flex" alignItems="center" gap={0.5}>
                                                        <span style={{ color: '#2563eb' }}>⬈</span>
                                                        <span>{item.ctr}</span>
                                                    </Box>
                                                    <Box display="flex" alignItems="center" gap={0.5}>
                                                        <span style={{ color: '#f59e0b' }}>✧</span>
                                                        <span>{item.conv}</span>
                                                    </Box>
                                                    <span style={{ color: '#ccc' }}>△</span>
                                                </Box>
                                            </TableCell>

                                            {/* Tags */}
                                            <TableCell>
                                                <Button className="btn sm" variant="outlined" onClick={() => setOpen1(true)}>
                                                    Edit Tags
                                                </Button>
                                            </TableCell>

                                            {/* Drag */}
                                            <TableCell >
                                                <IconButton className="drag_btn">
                                                    <DragHandleIcon />
                                                </IconButton>
                                            </TableCell>

                                            {/* Action */}
                                            <TableCell align="center">
                                                <IconButton className="action_btn" onClick={() => navigate('/home-layout/view')}>
                                                    <VisibilityOutlinedIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                </div>
               
            </div>

            <CreateNewHomeLayout open={open} onClose={handleCloseModal} setOpen={setOpen} />
            <EditTags open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />

        </>
    )
};
export default HomeLayout;